import get from 'lodash/get';
import { AnyAction } from 'redux';

/**
 * Flux Standard Action 형태를 따르는 두 액션을 전달받아서 각 액션의 meta 속성에
 * 전달받은 key 내부의 값을 병합한 새로운 배열을 반환합니다.
 *
 * @example
 * const a = {
 *   type: 'A',
 *   meta: {
 *     analytics: [
 *       { type: 'AA1' },
 *       { type: 'AA2' }
 *     ]
 *   }
 * };
 * const b = {
 *   type: 'B',
 *   meta: {
 *     analytics: [
 *       { type: 'BB' }
 *     ]
 *   }
 * }
 * expect(mergeMetaData(a, b, 'analytics')).toEqual([
 *   { type: 'AA1' },
 *   { type: 'AA2' },
 *   { type: 'BB' },
 * ]);
 */

export default function mergeMetaData(
  a: AnyAction,
  b: AnyAction,
  key: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): any[] {
  const path = `meta.${key}`;
  return [...get(a, path, []), ...get(b, path, [])];
}
